import React, { memo, useState, useEffect } from 'react';
import '../css/deferred-profile-avatar.css';

const scheduleDeferred = (fn) => {
  if (typeof window === 'undefined') {
    fn();
    return 0;
  }
  if (typeof window.requestIdleCallback === 'function') {
    return window.requestIdleCallback(fn, { timeout: 400 });
  }
  return window.setTimeout(fn, 0);
};

const cancelDeferred = (id) => {
  if (typeof window === 'undefined') return;
  if (typeof window.cancelIdleCallback === 'function') {
    window.cancelIdleCallback(id);
  } else {
    clearTimeout(id);
  }
};

const DeferredProfileAvatar = memo(function DeferredProfileAvatar({
  src,
  initials,
  size = 64,
  className = '',
  imgClassName = '',
}) {
  const [mountImage, setMountImage] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setMountImage(false);
    setLoaded(false);
    setBroken(false);
    if (!src) return undefined;
    let cancelled = false;
    const id = scheduleDeferred(() => {
      if (!cancelled) setMountImage(true);
    });
    return () => {
      cancelled = true;
      cancelDeferred(id);
    };
  }, [src]);

  const letter = (initials || '?').charAt(0).toUpperCase();
  const showFallback = !src || broken || !loaded;
  const fontPx = Math.max(12, Math.round(size * 0.38));

  return (
    <div
      className={`deferred-profile-avatar-wrap ${className}`.trim()}
      style={{ width: size, height: size, borderRadius: '50%' }}
    >
      {showFallback && (
        <div
          className="deferred-profile-avatar-fallback"
          style={{ fontSize: `${fontPx}px`, borderRadius: '50%' }}
          aria-hidden
        >
          {letter}
        </div>
      )}
      {src && mountImage && !broken && (
        <img
          src={src}
          alt=""
          width={size}
          height={size}
          loading="lazy"
          decoding="async"
          fetchPriority="low"
          className={`deferred-profile-avatar-img${loaded ? ' deferred-profile-avatar-img--visible' : ''} ${imgClassName}`.trim()}
          style={{ borderRadius: '50%' }}
          onLoad={() => setLoaded(true)}
          onError={() => setBroken(true)}
        />
      )}
    </div>
  );
});

export default DeferredProfileAvatar;
